import React, { useState, useEffect, useRef } from "react";

import MICLogo from "../pages/main/pic/MICLogo.png";
import { format12h } from "../utils/date";

export default function PrayerBoardBackDesk({
  data,
  title = "Prayer & Iqamah Times",
}) {
  if (!data) return null;

  const rows = [
    { label: "Fajr", time: data.fajr, iqamah: data.fajrIqamah },
    { label: "Dhuhr", time: data.dhuhr, iqamah: data.dhuhrIqamah },
    { label: "Asr", time: data.asr, iqamah: data.asrIqamah },
    { label: "Maghrib", time: data.maghrib, iqamah: data.maghribIqamah },
    { label: "Isha", time: data.isha, iqamah: data.ishaIqamah },
  ];

  // below is for change the background to dark blue when preyer time thrashhold finishes 🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽    🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽
  // below is for change the background to dark blue when preyer time thrashhold finishes 🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽    🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽
  const [currentPrayer, setCurrentPrayer] = useState("");
  useEffect(() => {
    const checkPrayer = () => {
      const today = new Date();
      const todayDate = today.toLocaleDateString("en-US"); // "12/14/2025"
      // Your dataset uses "12/14/25" instead of "2025"
      const todayShort = todayDate.replace(/(\d+)$/, (y) => y.slice(-2)); // "12/14/25"
      // console.log(todayShort);
      // Find today's row
      // Normalize both to the same format
      function normalizeDate(str) {
        const [month, day, year] = str.split("/");
        return `${Number(month)}/${Number(day)}/${year}`;
      }

      const todayData =
        data && normalizeDate(data.date) === normalizeDate(todayShort);
      // console.log(data && data);
      // console.log(todayData);
      // console.log(data);

      // console.log(todayData.Fajr);
      // console.log(data && data?.fajr);

      // console.log(timeToSeconds(todayData.Fajr));
      // console.log(
      //   data?.fajr && data.fajr !== "null" && data?.fajr.trim() !== ""
      //     ? data?.fajr
      //         .split(":")
      //         .map(Number)
      //         .reduce((acc, v, i) => acc + v * (i ? 60 : 3600), 0)
      //     : null
      // );
      // console.log(
      //   data?.fajr?.includes(":")
      //     ? data?.fajr
      //         .split(":")
      //         .map(Number)
      //         .reduce((acc, v, i) => acc + v * (i ? 60 : 3600), 0)
      //     : null
      // );
      // console.log(todayData);

      function timeToSeconds(timeStr) {
        const [h, m] = timeStr && timeStr.split(":").map(Number);
        return h * 3600 + m * 60;
      }

      const fajr = data && timeToSeconds(data?.fajr);
      // console.log(fajr);

      const dhuhr = data && timeToSeconds(data?.dhuhr);
      // console.log(dhuhr);

      const asr = data && timeToSeconds(data?.asr);
      // console.log(asr);

      const maghrib = data && timeToSeconds(data?.maghrib);
      // console.log(maghrib);

      const isha = data && timeToSeconds(data?.isha);
      // console.log(isha);

      const nowSec =
        today.getHours() * 3600 + today.getMinutes() * 60 + today.getSeconds();

      // console.log(nowSec);

      if (nowSec >= fajr && nowSec < dhuhr) {
        setCurrentPrayer("Fajr");
      } else if (nowSec >= dhuhr && nowSec < asr) {
        setCurrentPrayer("Dhuhr");
      } else if (nowSec >= asr && nowSec < maghrib) {
        setCurrentPrayer("Asr");
      } else if (nowSec >= maghrib && nowSec < isha) {
        setCurrentPrayer("Maghrib");
      } else {
        // Isha until next day's Fajr
        setCurrentPrayer("Isha");
      }
    };

    checkPrayer();
    const interval = setInterval(checkPrayer, 1000);
    return () => clearInterval(interval);
  }, [data]);

  // console.log(currentPrayer);

  // above is for change the background to dark blue when preyer time thrashhold finishes or changes🔚🔚🔚🔚🔝🔝🔝❌❌❌❌🔚🔚🔚🔚🔝🔝🔝🔚🔚🔚🔚🔝🔝🔝❌❌❌❌🔚🔚🔚🔚🔝🔝🔝
  // above is for change the background to dark blue when preyer time thrashhold finishes or changes🔚🔚🔚🔚🔝🔝🔝❌❌❌❌🔚🔚🔚🔚🔝🔝🔝🔚🔚🔚🔚🔝🔝🔝❌❌❌❌🔚🔚🔚🔚🔝🔝🔝

  return (
    <div
      className="left"
      style={{
        width: "100%",
        // height: "100vh",

        // filter: "drop-shadow(0 0 2px #6F47D3)",

        // background: "#316997ff",
        // background: "#3d7effff",
        background: "#ffffffff",
        marginBottom: "-25px",
        color: "#0070bb",
        // border: "2px solid red",
        float: "left",
      }}
    >
      <div
        className="lontainer wrapper "
        style={{
          marginTop: "-35px",
          // marginBottom: "-10px",
        }}
      >
        <img
          src={MICLogo}
          className="icon-image"
          alt="Left Icon"
          // class=""
          style={{
            height: 90,
            width: 90,
            marginTop: "30px",

            marginRight: "75px",
            //  gap: '100px'
          }}
        />

        <h3
          // className="word"
          // id="myText"
          style={{
            textAlign: "center",
            // marginTop: "1px",
            // marginBottom: "30px",
            fontSize: "45px",
            // fontFamily: "DM Sans, sans-serif",
            fontFamily: "Quicksand, sans-serif",

            fontStyle: "normal",
            // display: 'inline',
            letterSpacing: 4,
            // letterSpacing: "6px",
            color: "#0070bb",
            // textShadow: "2px 2px #1c7a1f",
          }}
        >
          MIDDLETOWN ISLAMIC CENTER (NEW YORK)
        </h3>
        <img
          src={MICLogo}
          className="icon-image"
          alt="Right Icon"
          style={{
            height: 90,
            width: 90,
            marginTop: "30px",
            marginLeft: "75px",
            //  gap: '100px'
          }}
        />
      </div>
      <div
        className="Table-Title-div"
        style={{
          marginTop: "-50px",
        }}
      >
        <table
          style={{
            width: "100%",

            fontSize: "30px",
            border: "none !important",
            // filter: "drop-shadow(0 0 2px #6F47D3)",
          }}
        >
          <tr style={{}}>
            <td
              style={{
                width: "20%",

                // background: "#80CBC4",
              }}
            >
              <b> </b>
            </td>

            <td
              style={{
                width: "40%",
                textAlign: "center",
                fontFamily: "Quicksand, sans-serif",
                fontWeight: "bold",

                // border: "1px solid #dddddd",
                // background: "#80CBC4",
              }}
            >
              ATHAN
            </td>

            <td
              style={{
                width: "40%",
                fontFamily: "Quicksand, sans-serif",
                textAlign: "center",
                // border: "1px solid #dddddd",
                // background: "#80CBC4",
                fontWeight: "bold",
              }}
            >
              IQAMAH
            </td>
          </tr>
        </table>
      </div>
      <div
        className={`box ${currentPrayer === "Fajr" ? "active bestseller" : ""}`}
      >
        <table
          style={{
            width: "100%",
            height: "20px",
            marginTop: "-2px",
            border: "none !important",
            // filter: "drop-shadow(0 0 2px #6F47D3)",
          }}
        >
          <tr>
            <td
              style={{
                width: "20%",
                fontFamily: "Quicksand, sans-serif",
                fontWeight: "bold",
                textAlign: "right",
                fontSize: "60px",
                verticalAlign: "middle",
                padding: 0,
                lineHeight: "1",
                height: "80px",
              }}
            >
              <b></b> FAJR
            </td>

            <td
              style={{
                width: "40%",
                textAlign: "right",
                fontWeight: "bold",
                fontSize: "90px",
                letterSpacing: -4,
                fontFamily: "Quicksand, sans-serif",
                borderRight: "1px solid #dddddd",
                borderLeft: "1px solid #dddddd",
                padding: 0,
                lineHeight: "1",
                height: "80px",
                verticalAlign: "middle",
              }}
            >
              {/* 56:56 PM <br /> */}
              {/* {formatTimeAMPM(bb.Fajr)}
               */}
              {data && format12h(data?.fajr)}
            </td>

            <td
              style={{
                width: "40%",
                fontSize: "90px",
                letterSpacing: -4,
                fontFamily: "Quicksand, sans-serif",
                textAlign: "center",
                fontWeight: "bold",
                padding: 0,
                lineHeight: "1",
                height: "80px",
                verticalAlign: "middle",
              }}
            >
              {/* {formatTimeAMPM(bb.Fajr_Iqamah)} */}
              {data && format12h(data?.fajrIqamah)}
            </td>
          </tr>
        </table>
      </div>
      <div
        className={`box ${
          currentPrayer === "Dhuhr" ? "active bestseller" : ""
        }`}
      >
        <table
          style={{
            width: "100%",
            marginTop: "-2px",
            border: "none !important",
            // filter: "drop-shadow(0 0 2px #6F47D3)",
          }}
        >
          <tr>
            <td
              style={{
                width: "20%",
                fontFamily: "Quicksand, sans-serif",
                fontWeight: "bold",
                textAlign: "right",
                fontSize: "60px",
                verticalAlign: "middle",
                padding: 0,
                lineHeight: "1",
                height: "80px",
              }}
            >
              <b></b>DHUHR
            </td>

            <td
              style={{
                width: "40%",
                textAlign: "right",
                fontWeight: "bold",
                fontSize: "90px",
                letterSpacing: -4,
                fontFamily: "Quicksand, sans-serif",
                borderRight: "1px solid #dddddd",
                borderLeft: "1px solid #dddddd",
                padding: 0,
                lineHeight: "1",
                height: "80px",
                verticalAlign: "middle",
              }}
            >
              {/* {formatTimeAMPM(bb.Dhuhr)} */}
              {data && format12h(data?.dhuhr)}
            </td>

            <td
              style={{
                width: "40%",
                fontSize: "90px",
                letterSpacing: -4,
                fontFamily: "Quicksand, sans-serif",
                textAlign: "center",
                fontWeight: "bold",
                padding: 0,
                lineHeight: "1",
                height: "80px",
                verticalAlign: "middle",
              }}
            >
              {/* {formatTimeAMPM(bb.Dhuhr_Iqamah)} */}
              {data && format12h(data?.dhuhrIqamah)}
            </td>
          </tr>
        </table>
      </div>
      <div
        className={`box ${currentPrayer === "Asr" ? "active bestseller" : ""}`}
      >
        <table
          style={{
            width: "100%",
            marginTop: "-2px",
            border: "none !important",
            // filter: "drop-shadow(0 0 2px #6F47D3)",
          }}
        >
          <tr style={{}}>
            <td
              style={{
                width: "20%",
                fontFamily: "Quicksand, sans-serif",
                fontWeight: "bold",
                textAlign: "right",
                fontSize: "60px",
                verticalAlign: "middle",
                padding: 0,
                lineHeight: "1",
                height: "80px",
              }}
            >
              <b></b>ASR
            </td>

            <td
              style={{
                width: "40%",
                textAlign: "right",
                fontWeight: "bold",
                fontSize: "90px",
                letterSpacing: -4,
                fontFamily: "Quicksand, sans-serif",
                borderRight: "1px solid #dddddd",
                borderLeft: "1px solid #dddddd",
                padding: 0,
                lineHeight: "1",
                height: "80px",
                verticalAlign: "middle",
              }}
            >
              {/* {formatTimeAMPM(bb.Asr)} */}
              {data && format12h(data?.asr)}
            </td>

            <td
              style={{
                width: "40%",
                fontSize: "90px",
                letterSpacing: -4,
                fontFamily: "Quicksand, sans-serif",
                textAlign: "center",
                fontWeight: "bold",
                padding: 0,
                lineHeight: "1",
                height: "80px",
                verticalAlign: "middle",
              }}
            >
              {/* {formatTimeAMPM(bb.Asr_Iqamah)} */}
              {data && format12h(data?.asrIqamah)}
            </td>
          </tr>
        </table>
      </div>
      <div
        className={`box ${
          currentPrayer === "Maghrib" ? "active bestseller" : ""
        }`}
      >
        <table
          style={{
            width: "100%",
            marginTop: "-2px",
            border: "none !important",
            // filter: "drop-shadow(0 0 2px #6F47D3)",
          }}
        >
          <tr style={{}}>
            <td
              style={{
                width: "20%",
                fontFamily: "Quicksand, sans-serif",
                fontWeight: "bold",
                textAlign: "right",
                fontSize: "60px",
                verticalAlign: "middle",
                padding: 0,
                lineHeight: "1",
                height: "80px",
              }}
            >
              <b></b>MAGHRIB
            </td>

            <td
              style={{
                width: "40%",
                textAlign: "right",
                fontWeight: "bold",
                fontSize: "90px",
                letterSpacing: -4,
                fontFamily: "Quicksand, sans-serif",
                borderRight: "1px solid #dddddd",
                borderLeft: "1px solid #dddddd",
                padding: 0,
                lineHeight: "1",
                height: "80px",
                verticalAlign: "middle",
              }}
            >
              {/* {formatTimeAMPM(bb.Maghrib)} */}
              {data && format12h(data?.maghrib)}
            </td>

            <td
              style={{
                width: "40%",
                fontSize: "90px",
                letterSpacing: -4,
                fontFamily: "Quicksand, sans-serif",
                textAlign: "center",
                fontWeight: "bold",
                padding: 0,
                lineHeight: "1",
                height: "80px",
                verticalAlign: "middle",
              }}
            >
              {/* {formatTimeAMPM(bb.Maghrib_Iqamah)} */}
              {data && format12h(data?.maghribIqamah)}
            </td>
          </tr>
        </table>
      </div>
      <div
        className={`box ${currentPrayer === "Isha" ? "active bestseller" : ""}`}
      >
        <table
          style={{
            width: "100%",
            marginTop: "-2px",
            border: "none !important",
            // filter: "drop-shadow(0 0 2px #6F47D3)",
          }}
        >
          <tr style={{}}>
            <td
              style={{
                width: "20%",
                fontFamily: "Quicksand, sans-serif",
                fontWeight: "bold",
                textAlign: "right",
                fontSize: "60px",
                verticalAlign: "middle",
                padding: 0,
                lineHeight: "1",
                height: "80px",
              }}
            >
              <b></b>ISHA
            </td>

            <td
              style={{
                width: "40%",
                textAlign: "right",
                fontWeight: "bold",
                fontSize: "90px",
                letterSpacing: -4,
                fontFamily: "Quicksand, sans-serif",
                borderRight: "1px solid #dddddd",
                borderLeft: "1px solid #dddddd",
                padding: 0,
                lineHeight: "1",
                height: "80px",
                verticalAlign: "middle",
              }}
            >
              {/* {formatTimeAMPM(bb.Isha)} */}
              {data && format12h(data?.isha)}
            </td>

            <td
              style={{
                width: "40%",
                fontSize: "90px",
                letterSpacing: -4,
                fontFamily: "Quicksand, sans-serif",
                textAlign: "center",
                fontWeight: "bold",
                padding: 0,
                lineHeight: "1",
                height: "80px",
                verticalAlign: "middle",
              }}
            >
              {/* {formatTimeAMPM(bb.Isha_Iqamah)} */}
              {data && format12h(data?.ishaIqamah)}
            </td>
          </tr>
        </table>
      </div>
      <div className="box">
        <table
          style={{
            width: "100%",
            marginTop: "-2px",
            border: "none !important",
            // filter: "drop-shadow(0 0 2px #6F47D3)",
          }}
        >
          <tr style={{}}>
            <td
              style={{
                width: "20%",
                fontFamily: "Quicksand, sans-serif",
                fontWeight: "bold",
                textAlign: "right",
                fontSize: "60px",
                verticalAlign: "middle",
                padding: 0,
                lineHeight: "1",
                height: "80px",
              }}
            >
              <b></b>JUMUAH
            </td>

            <td
              style={{
                width: "40%",
                textAlign: "right",
                fontWeight: "bold",
                fontSize: "90px",
                letterSpacing: -4,
                fontFamily: "Quicksand, sans-serif",
                borderRight: "1px solid #dddddd",
                borderLeft: "1px solid #dddddd",
                padding: 0,
                lineHeight: "1",
                height: "80px",
                verticalAlign: "middle",
              }}
            >
              {/* 1:00 PM */}
              {data && format12h(data?.jumuah)}
            </td>

            <td
              style={{
                width: "40%",
                fontSize: "90px",
                letterSpacing: -4,
                fontFamily: "Quicksand, sans-serif",
                textAlign: "center",
                fontWeight: "bold",
                padding: 0,
                lineHeight: "1",
                height: "80px",
                verticalAlign: "middle",
              }}
            >
              {data && format12h(data?.jumuahIqamah)}
            </td>
          </tr>
        </table>
      </div>
    </div>
  );
}
